<div class="genre">
    <nav class="navbar pl-0">
        <a class="navbar-brand pl-0" href="#">
            <img src="../images/icons/chevron-left.svg" alt="go back"> Go back
        </a>
    </nav>
    <div class="row">
        <h2 class="mt-2"> {{ genre }}</h2>
    </div>
    <div class="row">
        <div class="col-12">
            <h4 class="mt-4">Premieres</h4>
            <h5 style="opacity: 0.5" class="mt-4">No upcoming premieres at this time</h5>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h4 class="mt-4">Most Popular</h4>
            <h5 style="opacity: 0.5" class="mt-4">No popular artist at this time</h5>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h4 class="mt-4">Artists</h4>
        </div>
    </div>
</div>
